import * as Sentry from "@sentry/browser";
import {
  unsetUserAgreeToEngagementsTerms
} from '../../../components/Engagements/Libraries/UserAgreeEngagementsTerms.lib';
import {
  KEY__CREDENTIAL__PRIMARY
} from '../../../dictionaries/Credential.dic';
import Core from '../../Core';
import Definition from '../../Definition';
import globalErrorHandler from '../../Error/globalErrorHandler.fun';
import {
  validateEmail
} from '../../GenericTools.lib';
import Http from '../../Http';
import {
  Obj
} from '../../Object.lib';
import Store from '../../Store';
import {
  trim
} from '../../String.lib';

export const ROLE__SYS_ADMIN = 'SysAdmin';
export const ROLE__LIMITED_RECRUITER = 'LimitedRecruiter';
export const ROLE__TRUSTED_RECRUITER = 'TrustedRecruiter';
export const ROLE__EMPLOYER_RECRUITER = 'EmployerRecruiter';
export const URL__JWT__EXPIRED = '/#/jwt/expired';
export const URL__JWT__SESSION = '/#/jwt/session';
export const URL__JWT__INVALID = '/#/jwt/invalid';

export function logout({ redirect = '/login' } = {}) {
  Sentry.setUser();
  Store.remove("ui-version");
  Store.remove("history");
  Store.remove("BE");
  Store.remove("FE");
  Store.remove("email");
  Store.remove("session");
  unsetUserAgreeToEngagementsTerms();
  setTimeout(() => {
    if (trim(redirect)) {
      document.location.href = redirect;
    }
    document.location.reload();
  }, 1000);
}

export async function login(inputs) {
  try {
    const response = Obj(
      await Http.post(
        Core.getApi("Accounts/loginWith2FA"),
        inputs
      )
    );
    if (response.id) {
      return Obj(setSession({ session: response }));
    }
    return response;
  }
  catch (error) {
    globalErrorHandler(error);
  }
}

export async function verify2FACode(inputs) {
  try {
    Core.showLoader('Verifying 2FA code...');
    const response = Obj(
      await Http.post(
        Core.getApi("Accounts/verify2FACode"),
        inputs
      )
    );
    if (response.id) {
      return Obj(setSession({ session: response }));
    }
    Core.hideMessage();
    return response;
  }
  catch (error) {
    globalErrorHandler(error);
  }
}

export function setSession({ session = {}, redirect = Store.get("path") }) {
  if (session.id) {
    if (Definition.test("state", session.user.state, /inactive/)) {
      Core.showError('User is inactive');
    }
    else {
      session.role = session.role || session.user.role;
      Store.set("email", session.user.email);
      Store.set("session", session);
      Sentry.setUser({
        email: session.user.email,
        id: session.user.id
      });
      window["setFullStory"]();
      setTimeout(() => {
        if (trim(redirect)) {
          document.location.href = redirect;
        }
        document.location.reload();
      }, 1000);
    }
  }
  else {
    Core.showError('Unexpected error');
  }
}

export async function exchangeJWTToken({ employerId, jwt }) {
  try {
    Core.logout();
    const session = Obj(
      await Http.post(Core.getApi(`Accounts/jwt?jwt=${jwt}`))
    );
    session.employerId = employerId;
    setSession({ session });
  }
  catch (error) {
    if (employerId) {
      document.location.href = URL__JWT__EXPIRED;
      document.location.reload();
    }
    else {
      document.location.href = URL__JWT__INVALID;
      document.location.reload();
    }
  }
}

export async function generateMagicLink({ email }) {
  if (validateEmail(email)) {
    let compiled = await Http.get(Core.getApi(`Employers/_generateMagicLink`), { email }).catch(Core.showError);
    let { rendered = {}, mixins = {}, expiration } = compiled || {};
    let { subject = '', bodyHtml = '' } = rendered;
    let { from } = mixins;
    let error = { error: true };
    if (from && String(bodyHtml || '').includes('POST_PROCESSING')) {
      let sent = await require('../Email/Email.lib').sendSafeEmail({
        from,
        to: email,
        subject,
        html: bodyHtml,
        source: 'Session_lib__generateMagicLink',
        key: KEY__CREDENTIAL__PRIMARY,
      });
      if (sent) {
        return { expiration };
      }
      else {
        return error;
      }
    }
    else {
      return error;
    }
  }
  else {
    Core.showError(`Invalid email`);
  }
  return false;
}

export async function getEmployerPendingsURL({ accountId }) {
  return Http.get(
    Core.getApi('Accounts/_getEmployerPendingsURL'),
    { accountId }
  );
}
